import React, { useEffect, useState } from "react";
import { MyCampaignsImg } from "../../../static/constant/imgConstants";
import BottomNavigation from "./BrandCampaignLayout/BottomNavigation";
import { useDispatch, useSelector } from "react-redux";
import useOS from "../../utility/useOS/useOS";
import {
  setBrandCampaignCreationData,
  setBrandCampaignCreationStep,
} from "../../../store/publicStore/actions/utilsActions/utilsActions";
import { getMyBrandBusinessDetailForAgency } from "../../../store/agencyStore/actions/getMyBrandBusinessDetailForAgencyActions";

const BasicDetails = () => {
  const dispatch = useDispatch();
  const os = useOS();

  const { brandCampaignCreationStep, brandCampaignCreationData } = useSelector(
    (state) => state.utilReducers
  );

  const getUserInfoReducerData = useSelector(state => state.getUserInfoReducer.data);

  const [campaignName, setCampaignName] = useState(
    brandCampaignCreationData?.basicDetails?.campaignName
      ? brandCampaignCreationData?.basicDetails?.campaignName
      : ""
  );
  const [campaignPurpose, setCampaignPurpose] = useState(
    brandCampaignCreationData?.basicDetails?.campaignPurpose
      ? brandCampaignCreationData?.basicDetails?.campaignPurpose
      : ""
  );
  const [platform, setPlatform] = useState(
    brandCampaignCreationData?.basicDetails?.platform
      ? brandCampaignCreationData?.basicDetails?.platform
      : ""
  );
  const [campaignType, setCampaignType] = useState(
    brandCampaignCreationData?.basicDetails?.campaignType
      ? brandCampaignCreationData?.basicDetails?.campaignType
      : "Banner"
  );
  const [referralCode, setReferralCode] = useState(
    brandCampaignCreationData?.basicDetails?.referralCode
      ? brandCampaignCreationData?.basicDetails?.referralCode
      : ""
  );
  const [errors, setErrors] = useState({});

  const [selectedBrandId, setSelectedBrandId] = useState(
    brandCampaignCreationData?.basicDetails?.selectedBrandId
      ? brandCampaignCreationData?.basicDetails?.selectedBrandId
      : ""
  );
  const [brandList, setBrandList] = useState([]);

  const campaignTypeData = [
    {
      id: "",
      campaignType: "Banner",
      campaignTypeIcon: MyCampaignsImg.mycampaigns1,
    },
    {
      id: "",
      campaignType: "Video",
      campaignTypeIcon: MyCampaignsImg.mycampaigns2,
    },
    {
      id: "",
      campaignType: "User Generated Content",
      campaignTypeIcon: MyCampaignsImg.mycampaigns3,
    },
    {
      id: "",
      campaignType: "Brand Generated Content",
      campaignTypeIcon: MyCampaignsImg.mycampaigns4,
    },
  ];

  // Validate the form and return errors
  const validateForm = (data) => {
    let formErrors = {};
    if (getUserInfoReducerData.userType === 'AGENCY') {
      if (!data.selectedBrandId.trim()) {
        formErrors.selectedBrandId = "Brand Name is required";
      }
    }
    if (!data.campaignName.trim()) {
      formErrors.campaignName = "Campaign Name is required";
    }
    if (!data.campaignPurpose.trim()) {
      formErrors.campaignPurpose = "Campaign Purpose is required";
    }
    if (!data.platform) {
      formErrors.platform = "Social Media Platform is required";
    }
    if (!data.campaignType) {
      formErrors.campaignType = "Campaign Type is required";
    }

    return formErrors;
  };

  const handleNext = () => {
    console.log("brandCampaignCreationStep :", brandCampaignCreationStep);

    // Validate form data
    const formErrors = validateForm({
      selectedBrandId,
      campaignName,
      campaignPurpose,
      platform,
      campaignType,
      referralCode,
    });

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors); // Show errors if validation fails
    } else {
      // Clear errors and save data to Redux store
      setErrors({});
      console.log(
        "Successfully data from basic details page",
        brandCampaignCreationData?.basicDetails
      );
      // Dispatch the campaign data to Redux
      dispatch(
        setBrandCampaignCreationData({
          basicDetails: {
            selectedBrandId: selectedBrandId,
            campaignName: campaignName,
            campaignPurpose: campaignPurpose,
            platform: platform,
            campaignType: campaignType,
            referralCode: referralCode,
          },
          contentDetails: {
            startDate: brandCampaignCreationData?.contentDetails?.startDate,
            endDate: brandCampaignCreationData?.contentDetails?.endDate,
            bannerTemplate:
              brandCampaignCreationData?.contentDetails?.bannerTemplate,
            selectedBannerName:
              brandCampaignCreationData?.contentDetails?.selectedBannerName,
            videoPosition:
              brandCampaignCreationData?.contentDetails?.videoPosition,
            mediaFileLink:
              brandCampaignCreationData?.contentDetails?.mediaFileLink,
            mediaFileName:
              brandCampaignCreationData?.contentDetails?.mediaFileName,
            script: brandCampaignCreationData?.contentDetails?.script,
            dialogue: brandCampaignCreationData?.contentDetails?.dialogue,
            backgroundColor:
              brandCampaignCreationData?.contentDetails?.backgroundColor,
            otherProperties:
              brandCampaignCreationData?.contentDetails?.otherProperties,
            isLocationRequired:
              brandCampaignCreationData?.contentDetails?.isLocationRequired,
            isBrandApprovalRequired:
              brandCampaignCreationData?.contentDetails
                ?.isBrandApprovalRequired,
            uploadDuration:
              brandCampaignCreationData?.contentDetails?.uploadDuration,
            videoTitle: brandCampaignCreationData?.contentDetails?.videoTitle,
            videoDescription: brandCampaignCreationData?.contentDetails?.videoDescription,
            selectedGenre: brandCampaignCreationData?.contentDetails?.selectedGenre,
            referenceVideoUpload: brandCampaignCreationData?.contentDetails?.referenceVideoUpload,
            descriptionLink: brandCampaignCreationData?.contentDetails?.descriptionLink,
          },
          audienceDemographicDetails: {
            ageGroup:
              brandCampaignCreationData?.audienceDemographicDetails?.ageGroup,
            country:
              brandCampaignCreationData?.audienceDemographicDetails?.country,
            niche: brandCampaignCreationData?.audienceDemographicDetails?.niche,
            region:
              brandCampaignCreationData?.audienceDemographicDetails?.region,
            gender:
              brandCampaignCreationData?.audienceDemographicDetails?.gender,
            state: brandCampaignCreationData?.audienceDemographicDetails?.state,
            city: brandCampaignCreationData?.audienceDemographicDetails?.city,
          },
        })
      );

      // Proceed to the next step
      dispatch(setBrandCampaignCreationStep(brandCampaignCreationStep + 1));
    }
  };

  useEffect(() => {
    dispatch(getMyBrandBusinessDetailForAgency({}, (status, response, message) => {
      if (status === 200) {
        setBrandList(response);
      } else {
        setBrandList([]);
      }
    }));
  }, []);

  return (
    <div className="w-full h-[80%] bg-[#FFFFFF66] shadow-xl shadow-[#E3E8EF] rounded-[0.6rem] p-[3.2rem]">
      <div className="w-full h-full !overflow-y-scroll no-scrollbar">
        {getUserInfoReducerData.userType === 'AGENCY' && (
          <div className="w-full text-[1.6rem] mb-[2rem] inter-font font-[400]">
            <label className="text-[#111729]">
              Brand Name<span className="text-red-500">*</span>
            </label>
            <select
              className="w-full px-4  py-4 mt-[.8rem] border border-[#E3E8EF] rounded-lg focus:outline-none placeholder-[#677489]"
              value={selectedBrandId}
              onChange={(e) => {
                console.log("selectedBrand", e.target.value);
                setSelectedBrandId(e.target.value);
                setErrors((prevState) => {
                  const { selectedBrandId: _, ...updatedObject } = prevState;
                  return updatedObject;
                });
              }}
            >
              <option value="">Select a Brand</option>
              {brandList.map((brand, idx) => (
                <option key={idx} value={brand.brandId}>
                  {brand.name}
                </option>
              ))}
            </select>
            {errors.selectedBrandId && (
              <p className="text-red-500 text-[1.6rem] inter-font font-[400]">
                {errors.selectedBrandId}
              </p>
            )}
          </div>
        )}
        <div className="w-full gap-y-[2rem] flex flex-col md:flex-row justify-between items-top mb-[2.8rem]">
          <div className="w-full md:w-[49%] text-[1.6rem] inter-font font-[400]">
            <label className="text-[#111729]">
              Campaign Name<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter a Campaign Name"
              className="w-full px-4  py-4 mt-[.8rem] border border-[#E3E8EF] rounded-lg focus:outline-none placeholder-[#677489]"
              value={campaignName}
              onChange={(e) => {
                setCampaignName(e.target.value);
                setErrors((prevState) => {
                  const { campaignName, ...updatedObject } = prevState;
                  return updatedObject;
                });
              }}
            />
            {errors.campaignName && (
              <p className="text-red-500 text-[1.6rem] inter-font font-[400]">
                {errors.campaignName}
              </p>
            )}
          </div>
          <div className="w-full md:w-[49%] text-[1.6rem] inter-font font-[400]">
            <label className="text-[#111729]">
              Purpose of the Campaign
              <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter a Purpose of the Campaign"
              className="w-full px-4 py-4 mt-[.8rem] border border-[#E3E8EF] rounded-lg focus:outline-none placeholder-[#677489]"
              value={campaignPurpose}
              onChange={(e) => {
                setCampaignPurpose(e.target.value);
                setErrors((prevState) => {
                  const { ["campaignPurpose"]: _, ...updatedObject } =
                    prevState;
                  return updatedObject;
                });
              }}
            />
            {errors.campaignPurpose && (
              <p className="text-red-500 text-[1.6rem] inter-font font-[400]">
                {errors.campaignPurpose}
              </p>
            )}
          </div>
        </div>

        <div className="w-full flex flex-col gap-y-[2rem] md:flex-row justify-between items-top mb-[2.8rem]">
          <div className="w-full md:w-[49%]">
            <label className="text-[1.6rem] inter-font font-[400] text-[#111729]">
              Social Media Platform
              <span className="text-red-500">*</span>
            </label>
            <select
              className="w-full px-4 py-4 mt-[.8rem] text-[1.6rem] inter-font font-[400] border border-[#E3E8EF] rounded-lg focus:outline-none"
              value={platform}
              onChange={(e) => {
                setPlatform(e.target.value);
                setErrors((prevState) => {
                  const { platform: _, ...updatedObject } = prevState;
                  return updatedObject;
                });
              }}
            >
              <option value="" disabled>
                Select Platform
              </option>
              <option value="YOUTUBE">YOUTUBE</option>
              <option value="INSTAGRAM">
                INSTAGRAM
              </option>
              <option value="TIKTOK" disabled>
                TikTok (comming soon)
              </option>
            </select>
            {errors.platform && (
              <p className="text-red-500 text-[1.6rem] inter-font font-[400]">
                {errors.platform}
              </p>
            )}
          </div>
          <div className="w-full md:w-[49%] text-[1.6rem] inter-font font-[400]">
            <label className="text-[#111729]">
              Referral Code{/* <span className="text-red-500">*</span> */}
            </label>
            <input
              type="text"
              placeholder="Enter a Referral Code"
              className="w-full px-4 py-4 mt-[.8rem] border border-[#E3E8EF] rounded-lg focus:outline-none placeholder-[#677489]"
              value={referralCode}
              onChange={(e) => {
                setReferralCode(e.target.value);
              }}
            />
          </div>
        </div>

        <div className="w-full my-[2.5rem]">
          <h1 className="text-[1.6rem] text-[#111729] inter-font font-[400] mb-[.8rem]">
            Select Campaign Type <span className="text-red-500">*</span>
          </h1>

          <div className="flex flex-col sm:flex-row sm:flex-wrap justify-start items-center gap-[2rem]">
            {campaignTypeData?.map((type, i) => {
              const isSelected = campaignType === type.campaignType;

              const cardHeight = os === "iOS" ? "h-[22rem]" : "h-[19rem]";
              const iconWrapperHeight = os === "iOS" ? "h-[75%]" : "h-[68%]";
              const iconImageHeight =
                type.campaignType === "Brand Generated Content"
                  ? os === "iOS"
                    ? "h-[6rem]"
                    : "h-[5rem]"
                  : os === "iOS"
                    ? "h-[4rem]"
                    : "h-[3.1rem]";

              return (
                <div
                  key={i}
                  className={`w-full sm:w-[18rem] ${cardHeight} flex flex-col items-center justify-between border rounded-lg cursor-pointer 
                ${isSelected
                      ? "border-[#0D9B50] bg-[#DBEAE6]"
                      : "border-[#E3E8EF] bg-[#FFFFFF]"
                    } 
                hover:border-[#0D9B50] hover:bg-[#DBEAE6]/20`}
                  onClick={() => setCampaignType(type.campaignType)}
                >
                  <div
                    className={`${iconWrapperHeight} flex items-center justify-center`}
                  >
                    <div className={`${iconImageHeight}`}>
                      <img
                        src={type.campaignTypeIcon}
                        alt="icon"
                        className="w-full h-full object-contain"
                      />
                    </div>
                  </div>
                  <div className="h-[32%] mt-auto text-[#111729] inter-font font-[400] text-[1.6rem] text-center">
                    {type.campaignType}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <BottomNavigation
          isNextDisabled={Object.keys(errors).length > 0}
          handleNext={handleNext}
        />
      </div>
    </div>
  );
};

export default BasicDetails;
